import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ChatMessage } from '../../../models/chat-message';
import { EnumType } from '../../../models/enums/enum';
declare const $: any;

@Component({
	selector: 'app-chat-message-carrusel',
	templateUrl: './chat-message-carrusel.component.html',
	styleUrls: ['./chat-message-carrusel.component.scss']
})
export class ChatMessageCarruselComponent implements OnInit {

	@Input() index: number;
	@Input() elements: any;
	@Output() onOptionMessageClicked: EventEmitter<any> = new EventEmitter<any>();

	constructor() { }

	ngOnInit() {
		$(document).ready(function () {
			$(".carousel-group").not('.slick-initialized').slick({
				slidesToShow: 1,
				slidesToScroll: 1,
				prevArrow: `<div class="carousel-previous" style="display: flex;border-top-left-radius: 0.4em;border-bottom-left-radius: 0.4em;padding-right: 0.25em; align-items: center;">
                        <button type="button" class="slick-prev" style="background-color: #efefef; height: 50px; border: none; border-top-left-radius: 5px; border-bottom-left-radius: 5px;"><i class="fa fa-arrow-left" aria-hidden="true"></i></button>
                    </div>`,
				nextArrow: `<div class="carousel-next" style="display: flex;border-top-right-radius: 0.4em;border-bottom-right-radius: 0.4em;padding-left: 0.23em;  align-items: center;">
                        <button type="button" class="slick-next" style="background-color: #efefef; height: 50px; border: none; border-top-right-radius: 5px; border-bottom-right-radius: 5px;"><i class="fa fa-arrow-right" aria-hidden="true"></i></button>
                    </div>`
			})
		});

	}

	addMessage(item: any) {
		let element: ChatMessage = {
			senderName: EnumType.MessageSender.USER,
			time: new Date(),
			payload: {
				type: 'text',
				values: item.text,
				intent: item.intent
			}
		};
		this.onOptionMessageClicked.emit(element);
	}

	openUrl(link: string) {
		let url: string = '';
		if (!/^http[s]?:\/\//.test(link)) {
			url += 'http://';
		}
		url += link;
		window.open(url, "_blank");
	}
}
